
















import Vue, {PropType} from 'vue'

import {NavItem} from '../../stores/NavBar'

export default Vue.extend({
    props: {
        itemStyle: {
            default: 'icon',
            type: String as PropType<'icon' | 'list'>
        },
        item: Object as PropType<NavItem>
    },
    computed: {
        label(): string {
            return this.item!.label!.toUpperCase()
        }
    }
})
